<template>
  <tr>
  	<td>{{item.item_code}}</td>
    <td>{{item.title}}</td>
    <td>{{item.unit_name}}</td>
    <td class="text-xs-right">
      <span v-if="viewMode">{{ item.quantity }}</span>
      <v-edit-dialog v-else :return-value="quantity" lazy @open="open" @close="close"> {{ item.quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td class="text-xs-right" v-if="!viewMode">{{item.stock_quantity}}</td>
    <td class="align-right justify-end layout px-2" v-if="!viewMode">
      <v-btn flat icon @click="$emit('delete', index)">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'StockDispatchItem' ,
  props: {
    item: {
      required: true
    },
    index: {
      required: true
    },
    viewMode: {
      default: false
    }
  },
  data () {
    return {
      quantity: 1,
      quantityRules: [
        v => !!v || 'Quantity is required',
        v => /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Quantity must be valid'
      ]
    }
  },
  
  methods: {
  	open () {
      this.quantity = this.item.quantity
    },
    close () {
      this.item.quantity = this.item.allow_decimal ? this.quantity : parseInt(this.quantity)
    }
  },

  mounted () {
  	
  },

  computed: {

  },

  watch: {
  	
    'item.quantity' (val, oldVal) {
  		if (!val || val <= 0) {
        this.item.quantity = 1
  		}
  	}
    
  }
}
</script>